import {
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  useMutation,
  useQuery,
} from 'react-query';
import { TimesheetAPI } from 'api/timesheets';
import {
  ActivitiesApi,
  Activity,
  ActivityTypes,
} from 'api/timesheets/activities';
import { GENERAL_API_STALE } from 'config/query-config';

export const PROJECT_ACTIVITIES_KEY = 'pre-defined-project-activities';
export const NON_PROJECT_ACTIVITIES_KEY = 'pre-defined-non-project-activities';
export const ALL_ADHOC_ACTIVITIES_KEY = 'all-adhoc-activities';

export const usePredefinedProjectActivities = (
  options: UseQueryOptions<Activity[], unknown, Activity[], any> = {},
): UseQueryResult<Activity[]> => {
  return useQuery(
    PROJECT_ACTIVITIES_KEY,
    () => ActivitiesApi.get(ActivityTypes.Project),
    {
      ...options,
      staleTime: GENERAL_API_STALE,
    },
  );
};

export const useGetAllActivitiesInProject = (userId: number) => {
  return useQuery(
    ALL_ADHOC_ACTIVITIES_KEY,
    () => {
      return TimesheetAPI.getActivitiesOfUserInProject(userId, 'all');
    },
    {
      staleTime: GENERAL_API_STALE,
    },
  );
};

export const usePredefinedNonProjectActivities = (
  options: UseQueryOptions<Activity[], unknown, Activity[], any> = {},
): UseQueryResult<Activity[]> => {
  return useQuery(
    NON_PROJECT_ACTIVITIES_KEY,
    () => ActivitiesApi.get(ActivityTypes.NonProject),
    {
      staleTime: GENERAL_API_STALE,
      ...options,
    },
  );
};

export const useCreateActivityMutation = (
  type: ActivityTypes,
  options: UseMutationOptions<void, unknown, string> = {},
) => {
  return useMutation<void, unknown, string>(
    (name) => ActivitiesApi.create({ activityName: name, type }),
    options,
  );
};

export const useRemoveActivityMutation = (
  options: UseMutationOptions<void, unknown, { activityId: number }> = {},
) => {
  return useMutation<void, unknown, { activityId: number }>(
    ({ activityId }) => ActivitiesApi.remove(activityId),
    options,
  );
};
